export default "__VITE_ASSET__CaDaG$7E__"